import React, { useContext, useEffect } from 'react'
import { contextData } from '../../App'
import SummerDanceCamp from '../../components/SummerCamp/SummerCamp';
import Registration from '../../components/RegisterForm/RegisterForm';

function SummerCampPage() {

  const {isScrolled,setIsScrolled} = useContext(contextData);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsScrolled(true)
    return () => {
      setIsScrolled(false)
    }
  },[])

  return (
    <div className='pt-[114px]'>
        <SummerDanceCamp/>
    </div>
  )
}

export default SummerCampPage